import { Component, OnDestroy } from '@angular/core';

import { MatAccordion } from '@angular/material/expansion';
import { TranslatePipe } from '@ngx-translate/core';
import { MatExtensionPanelLeadComponent } from './mat-extension-panel-lead/mat-extension-panel-lead.component';
import { Lead } from '../../../lead.model';
import { RouteInformationService } from '../../route-information.service';
import { Subscription } from 'rxjs';

interface LeadsWithOrder {
  reachableLeads: Lead[];
  unreachableLeads: Lead[];
}

@Component({
  selector: 'app-selected-lead-list',
  imports: [MatAccordion, TranslatePipe, MatExtensionPanelLeadComponent],
  templateUrl: './selected-lead-list.component.html',
  styleUrl: './selected-lead-list.component.scss',
})
export class SelectedLeadListComponent implements OnDestroy {
  routeInformationSubscription: Subscription;
  leadsWithOrder: LeadsWithOrder = {
    reachableLeads: [],
    unreachableLeads: [],
  };

  constructor(public routeInformationService: RouteInformationService) {
    this.routeInformationSubscription =
      routeInformationService.redrawRoute$.subscribe(() => {
        const mapInformation = routeInformationService.getMapInformation();

        if (mapInformation.type === 'leadInformation') {
          this.leadsWithOrder = {
            reachableLeads: mapInformation.leads,
            unreachableLeads: [],
          };
        } else if (mapInformation.type === 'routeInformation') {
          this.leadsWithOrder = {
            reachableLeads: mapInformation.routeElements.map(
              (routeElement) => routeElement.targetLead,
            ),
            unreachableLeads: mapInformation.unreachableLeads,
          };
        }
      });
  }

  ngOnDestroy(): void {
    this.routeInformationSubscription.unsubscribe();
  }
}
